import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListMaterialAgents } from "../../../components/Admin/MaterialAgents/ListMaterialAgents/ListMaterialAgents";
import { useLanguage } from "../../../contexts";
import "./MaterialAgents.scss";

export function MaterialAgents() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    {
      menuItem: t("actives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListMaterialAgents active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListMaterialAgents active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="material-agents-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="material-agents-page-header-wrapper">
        <div className="material-agents-page-header">
          <span className="material-agents-page-title">{t("material_agents")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
